import { Dialog } from "@hubertai/hubert-component-library";
import { CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button, Heading, Text } from "../elements";

const NewCandidateModalPopup = () => {
    const { t } = useTranslation();

    return (
        <Dialog.Root defaultOpen>
            <Dialog.Content className="new-candidate-modal-popup">
                <div className="head-section">
                    <div className="icon-wrapper">
                        <CheckCircle size={32} />
                    </div>
                    <Heading level="h2">{t("Dashboard.NewCandidateModalPopup.Title")}</Heading>
                </div>
                <div className="body-section">
                    <Text block>{t("Dashboard.NewCandidateModalPopup.DescriptionLine1")}</Text>
                    <Text block>{t("Dashboard.NewCandidateModalPopup.DescriptionLine2")}</Text>
                </div>
                <div className="button-section">
                    <Dialog.Close>
                        <Button ariaLabel={t("Dashboard.NewCandidateModalPopup.ButtonText_LetsGo")}>
                            {t("Dashboard.NewCandidateModalPopup.ButtonText_LetsGo")}
                        </Button>
                    </Dialog.Close>
                </div>
            </Dialog.Content>
        </Dialog.Root>
    );
};

export default NewCandidateModalPopup;
